/* eslint-disable */
/*
/* This file is generated automatically by i18n preprocessor. Do not modify it directly.
 */
import { addLang, locale } from '../src/locale';

const defaultLocale = 'en-US';
const i18n = {
  "en-US": {
    "datepicker": {
      "now": "Now",
      "today": "Today",
      "cancel": "Cancel",
      "clear": "Clear",
      "confirm": "OK",
      "selectDate": "Select date",
      "selectTime": "Select time",
      "startDate": "Start Date",
      "endDate": "End Date",
      "startTime": "Start Time",
      "endTime": "End Time",
      "prevYear": "Previous Year",
      "nextYear": "Next Year",
      "year": "Year",
      "month1": "January",
      "month2": "February",
      "month3": "March",
      "month4": "April",
      "month5": "May",
      "month6": "June",
      "month7": "July",
      "month8": "August",
      "month9": "September",
      "month10": "October",
      "month11": "November",
      "month12": "December",
      "weeksShort": {
        "sun": "Sun",
        "mon": "Mon",
        "tue": "Tue",
        "wed": "Wed",
        "thu": "Thu",
        "fri": "Fri",
        "sat": "Sat"
      },
      "weeks": {
        "sun": "Sunday",
        "mon": "Monday",
        "tue": "Tuesday",
        "wed": "Wednesday",
        "thu": "Thursday",
        "fri": "Friday",
        "sat": "Saturday"
      },
      "months": {
        "jan": "Jan",
        "feb": "Feb",
        "mar": "Mar",
        "apr": "Apr",
        "may": "May",
        "jun": "Jun",
        "jul": "Jul",
        "aug": "Aug",
        "sep": "Sep",
        "oct": "Oct",
        "nov": "Nov",
        "dec": "Dec"
      },
      "nextMonth": "Next Month",
      "prevMonth": "Previous Month"
    }
  },
  "de-DE": {
    "datepicker": {
      "now": "Jetzt",
      "today": "Heute",
      "cancel": "Abbrechen",
      "clear": "Löschen",
      "confirm": "OK",
      "selectDate": "Datum auswählen",
      "selectTime": "Zeit auswählen",
      "startDate": "Startdatum",
      "endDate": "Enddatum",
      "startTime": "Startzeit",
      "endTime": "Endzeit",
      "prevYear": "Vorjahr",
      "nextYear": "Nächstes Jahr",
      "year": "Jahr",
      "month1": "Januar",
      "month2": "Februar",
      "month3": "März",
      "month4": "April",
      "month5": "Mai",
      "month6": "Juni",
      "month7": "Juli",
      "month8": "August",
      "month9": "September",
      "month10": "Oktober",
      "month11": "November",
      "month12": "Dezember",
      "weeksShort": {
        "sun": "So",
        "mon": "Mo",
        "tue": "Di",
        "wed": "Mi",
        "thu": "Do",
        "fri": "Fr",
        "sat": "Sa"
      },
      "weeks": {
        "sun": "Sonntag",
        "mon": "Montag",
        "tue": "Dienstag",
        "wed": "Mittwoch",
        "thu": "Donnerstag",
        "fri": "Freitag",
        "sat": "Samstag"
      },
      "months": {
        "jan": "Jan",
        "feb": "Feb",
        "mar": "Mär",
        "apr": "Apr",
        "may": "Mai",
        "jun": "Jun",
        "jul": "Jul",
        "aug": "Aug",
        "sep": "Sep",
        "oct": "Okt",
        "nov": "Nov",
        "dec": "Dez"
      },
      "nextMonth": "Nächster Monat",
      "prevMonth": "Letzter Monat"
    }
  },
  "es-ES": {
    "datepicker": {
      "now": "Ahora",
      "today": "Hoy",
      "cancel": "Cancelar",
      "clear": "Borrar",
      "confirm": "Aceptar",
      "selectDate": "Seleccionar fecha",
      "selectTime": "Seleccionar hora",
      "startDate": "Fecha de inicio",
      "endDate": "Fecha de finalización",
      "startTime": "Hora de inicio",
      "endTime": "Hora de finalización",
      "prevYear": "Año anterior",
      "nextYear": "Próximo año",
      "year": "Año",
      "month1": "Enero",
      "month2": "Febrero",
      "month3": "Marzo",
      "month4": "Abril",
      "month5": "Mayo",
      "month6": "Junio",
      "month7": "Julio",
      "month8": "Agosto",
      "month9": "Septiembre",
      "month10": "Octubre",
      "month11": "Noviembre",
      "month12": "Diciembre",
      "weeksShort": {
        "sun": "Dom.",
        "mon": "Lun.",
        "tue": "Mar.",
        "wed": "Mié.",
        "thu": "Jue.",
        "fri": "Vie.",
        "sat": "Sáb."
      },
      "weeks": {
        "sun": "Domingo",
        "mon": "Lunes",
        "tue": "Martes",
        "wed": "Miércoles",
        "thu": "Jueves",
        "fri": "Viernes",
        "sat": "Sábado"
      },
      "months": {
        "jan": "Ene",
        "feb": "Feb",
        "mar": "Mar",
        "apr": "Abr",
        "may": "May",
        "jun": "Jun",
        "jul": "Jul",
        "aug": "Ago",
        "sep": "Sep",
        "oct": "Oct",
        "nov": "Nov",
        "dec": "Dic"
      },
      "nextMonth": "Próximo Mes",
      "prevMonth": "Mes Anterior"
    }
  },
  "fr-FR": {
    "datepicker": {
      "now": "Maintenant",
      "today": "Aujourd’hui",
      "cancel": "Annuler",
      "clear": "Effacer",
      "confirm": "OK",
      "selectDate": "Sélectionner la date",
      "selectTime": "Sélectionner l’heure",
      "startDate": "Date de début",
      "endDate": "Date de fin",
      "startTime": "Heure de début",
      "endTime": "Heure de fin",
      "prevYear": "Année précédente",
      "nextYear": "Année suivante",
      "year": "Année",
      "month1": "Janvier",
      "month2": "Février",
      "month3": "Mars",
      "month4": "Avril",
      "month5": "Mai",
      "month6": "Juin",
      "month7": "Juillet",
      "month8": "Août",
      "month9": "Septembre",
      "month10": "Octobre",
      "month11": "Novembre",
      "month12": "Décembre",
      "weeksShort": {
        "sun": "Dim",
        "mon": "Lun",
        "tue": "Mar",
        "wed": "Mer",
        "thu": "Jeu",
        "fri": "Ven",
        "sat": "Sam"
      },
      "weeks": {
        "sun": "Dimanche",
        "mon": "Lundi",
        "tue": "Mardi",
        "wed": "Mercredi",
        "thu": "Jeudi",
        "fri": "Vendredi",
        "sat": "Samedi"
      },
      "months": {
        "jan": "Jan",
        "feb": "Fév",
        "mar": "Mar",
        "apr": "Avr",
        "may": "Mai",
        "jun": "Juin",
        "jul": "Juil",
        "aug": "Août",
        "sep": "Sep",
        "oct": "Oct",
        "nov": "Nov",
        "dec": "Déc"
      },
      "nextMonth": "Mois suivant",
      "prevMonth": "Mois précédent"
    }
  },
  "it-IT": {
    "datepicker": {
      "now": "Ora",
      "today": "Oggi",
      "cancel": "Annulla",
      "clear": "Cancella",
      "confirm": "OK",
      "selectDate": "Seleziona data",
      "selectTime": "Seleziona ora",
      "startDate": "Data di inizio",
      "endDate": "Data di fine",
      "startTime": "Ora di inizio",
      "endTime": "Ora di fine",
      "prevYear": "Anno scorso",
      "nextYear": "Anno prossimo",
      "year": "Anno",
      "month1": "Gennaio",
      "month2": "Febbraio",
      "month3": "Marzo",
      "month4": "Aprile",
      "month5": "Maggio",
      "month6": "Giugno",
      "month7": "Luglio",
      "month8": "Agosto",
      "month9": "Settembre",
      "month10": "Ottobre",
      "month11": "Novembre",
      "month12": "Dicembre",
      "weeksShort": {
        "sun": "Dom",
        "mon": "Lun",
        "tue": "Mar",
        "wed": "Mer",
        "thu": "Gio",
        "fri": "Ven",
        "sat": "Sab"
      },
      "weeks": {
        "sun": "Domenica",
        "mon": "Lunedì",
        "tue": "Martedì",
        "wed": "Mercoledì",
        "thu": "Giovedì",
        "fri": "Venerdì",
        "sat": "Sabato"
      },
      "months": {
        "jan": "Gen",
        "feb": "Feb",
        "mar": "Mar",
        "apr": "Apr",
        "may": "Mag",
        "jun": "Giu",
        "jul": "Lug",
        "aug": "Ago",
        "sep": "Set",
        "oct": "Ott",
        "nov": "Nov",
        "dec": "Dic"
      },
      "nextMonth": "Mese successivo",
      "prevMonth": "Mese precedente"
    }
  },
  "jp-JP": {
    "datepicker": {
      "now": "今すぐ",
      "today": "今日",
      "cancel": "キャンセル",
      "clear": "クリア",
      "confirm": "OK",
      "selectDate": "日付を選択",
      "selectTime": "時間を選択",
      "startDate": "開始日",
      "endDate": "終了日",
      "startTime": "開始時刻",
      "endTime": "終了時刻",
      "prevYear": "前の年",
      "nextYear": "次の年",
      "year": "年",
      "month1": "1月",
      "month2": "2月",
      "month3": "3月",
      "month4": "4月",
      "month5": "5月",
      "month6": "6月",
      "month7": "7月",
      "month8": "8月",
      "month9": "9月",
      "month10": "10月",
      "month11": "11月",
      "month12": "12月",
      "weeksShort": {
        "sun": "日",
        "mon": "月",
        "tue": "火",
        "wed": "水",
        "thu": "木",
        "fri": "金",
        "sat": "土"
      },
      "weeks": {
        "sun": "日曜日",
        "mon": "月曜日",
        "tue": "火曜日",
        "wed": "水曜日",
        "thu": "木曜日",
        "fri": "金曜日",
        "sat": "土曜日"
      },
      "months": {
        "jan": "1月",
        "feb": "2月",
        "mar": "3月",
        "apr": "4月",
        "may": "5月",
        "jun": "6月",
        "jul": "7月",
        "aug": "8月",
        "sep": "9月",
        "oct": "10月",
        "nov": "11月",
        "dec": "12月"
      },
      "nextMonth": "翌月",
      "prevMonth": "前月"
    }
  },
  "ko-KO": {
    "datepicker": {
      "now": "지금",
      "today": "오늘",
      "cancel": "취소",
      "clear": "지우기",
      "confirm": "확인",
      "selectDate": "날짜 선택",
      "selectTime": "시간 선택",
      "startDate": "시작 날짜",
      "endDate": "종료 날짜",
      "startTime": "시작 시간",
      "endTime": "종료 시간",
      "prevYear": "작년",
      "nextYear": "내년",
      "year": "년",
      "month1": "1월",
      "month2": "2월",
      "month3": "3월",
      "month4": "4월",
      "month5": "5월",
      "month6": "6월",
      "month7": "7월",
      "month8": "8월",
      "month9": "9월",
      "month10": "10월",
      "month11": "11월",
      "month12": "12월",
      "weeksShort": {
        "sun": "일",
        "mon": "월",
        "tue": "화",
        "wed": "수",
        "thu": "목",
        "fri": "금",
        "sat": "토"
      },
      "weeks": {
        "sun": "일요일",
        "mon": "월요일",
        "tue": "화요일",
        "wed": "수요일",
        "thu": "목요일",
        "fri": "금요일",
        "sat": "토요일"
      },
      "months": {
        "jan": "1월",
        "feb": "2월",
        "mar": "3월",
        "apr": "4월",
        "may": "5월",
        "jun": "6월",
        "jul": "7월",
        "aug": "8월",
        "sep": "9월",
        "oct": "10월",
        "nov": "11월",
        "dec": "12월"
      },
      "nextMonth": "다음달",
      "prevMonth": "지난달"
    }
  },
  "pl-PL": {
    "datepicker": {
      "now": "Teraz",
      "today": "Dziś",
      "cancel": "Anuluj",
      "clear": "Wyczyść",
      "confirm": "OK",
      "selectDate": "Wybierz datę",
      "selectTime": "Wybierz godzinę",
      "startDate": "Data rozpoczęcia",
      "endDate": "Data zakończenia",
      "startTime": "Godzina rozpoczęcia",
      "endTime": "Godzina zakończenia",
      "prevYear": "Poprzedni rok",
      "nextYear": "Następny rok",
      "year": "Rok",
      "month1": "Styczeń",
      "month2": "Luty",
      "month3": "Marzec",
      "month4": "Kwiecień",
      "month5": "Maj",
      "month6": "Czerwiec",
      "month7": "Lipiec",
      "month8": "Sierpień",
      "month9": "Wrzesień",
      "month10": "Październik",
      "month11": "Listopad",
      "month12": "Grudzień",
      "weeksShort": {
        "sun": "niedz.",
        "mon": "pon.",
        "tue": "wt.",
        "wed": "śr.",
        "thu": "czw.",
        "fri": "pt.",
        "sat": "sob."
      },
      "weeks": {
        "sun": "Niedziela",
        "mon": "Poniedziałek",
        "tue": "Wtorek",
        "wed": "Środa",
        "thu": "Czwartek",
        "fri": "Piątek",
        "sat": "Sobota"
      },
      "months": {
        "jan": "Styczeń",
        "feb": "Luty",
        "mar": "Marzec",
        "apr": "Kwiecień",
        "may": "Maj",
        "jun": "Czerwiec",
        "jul": "lip",
        "aug": "Sierpień",
        "sep": "Wrzesień",
        "oct": "Październik",
        "nov": "Listopad",
        "dec": "Grudzień"
      },
      "nextMonth": "Następny miesiąc",
      "prevMonth": "Poprzedni miesiąc"
    }
  },
  "pt-PT": {
    "datepicker": {
      "now": "Agora",
      "today": "Hoje",
      "cancel": "Cancelar",
      "clear": "Limpar",
      "confirm": "OK",
      "selectDate": "Selecione a data",
      "selectTime": "Selecione a hora",
      "startDate": "Data de início",
      "endDate": "Data de fim",
      "startTime": "Hora de início",
      "endTime": "Hora de fim",
      "prevYear": "Ano anterior",
      "nextYear": "Próximo ano",
      "year": "Ano",
      "month1": "Janeiro",
      "month2": "Fevereiro",
      "month3": "Março",
      "month4": "Abril",
      "month5": "Maio",
      "month6": "Junho",
      "month7": "Julho",
      "month8": "Agosto",
      "month9": "Setembro",
      "month10": "Outubro",
      "month11": "Novembro",
      "month12": "Dezembro",
      "weeksShort": {
        "sun": "Dom",
        "mon": "Seg",
        "tue": "Ter",
        "wed": "Qua",
        "thu": "Qui",
        "fri": "Sex",
        "sat": "Sáb"
      },
      "weeks": {
        "sun": "Domingo",
        "mon": "Segunda-feira",
        "tue": "Terça-feira",
        "wed": "Quarta-feira",
        "thu": "Quinta-feira",
        "fri": "Sexta-feira",
        "sat": "Sábado"
      },
      "months": {
        "jan": "Jan",
        "feb": "Fev",
        "mar": "Mar",
        "apr": "Abr",
        "may": "Mai",
        "jun": "Jun",
        "jul": "Jul",
        "aug": "Ago",
        "sep": "Set",
        "oct": "Out",
        "nov": "Nov",
        "dec": "Dez"
      },
      "nextMonth": "Mês que VEM",
      "prevMonth": "Mês passado"
    }
  },
  "ru-RU": {
    "datepicker": {
      "now": "Сейчас",
      "today": "Сегодня",
      "cancel": "Отмена",
      "clear": "Очистить",
      "confirm": "ОК",
      "selectDate": "Выберите дату",
      "selectTime": "Выберите время",
      "startDate": "Дата начала",
      "endDate": "Дата окончания",
      "startTime": "Время начала",
      "endTime": "Время окончания",
      "prevYear": "Предыдущий год",
      "nextYear": "Следующий год",
      "year": "Год",
      "month1": "Январь",
      "month2": "Февраль",
      "month3": "Март",
      "month4": "Апрель",
      "month5": "Май",
      "month6": "Июнь",
      "month7": "Июль",
      "month8": "Август",
      "month9": "Сентябрь",
      "month10": "Октябрь",
      "month11": "Ноябрь",
      "month12": "Декабрь",
      "weeksShort": {
        "sun": "Вс",
        "mon": "Пн",
        "tue": "Вт",
        "wed": "Ср",
        "thu": "Чт",
        "fri": "Пт",
        "sat": "Сб"
      },
      "weeks": {
        "sun": "Воскресенье",
        "mon": "Понедельник",
        "tue": "Вторник",
        "wed": "Среда",
        "thu": "Четверг",
        "fri": "Пятница",
        "sat": "Суббота"
      },
      "months": {
        "jan": "Янв",
        "feb": "Фев",
        "mar": "Мар",
        "apr": "Апр",
        "may": "Май",
        "jun": "Июн",
        "jul": "Июл",
        "aug": "Авг",
        "sep": "Сен",
        "oct": "Окт",
        "nov": "Ноя",
        "dec": "Дек"
      },
      "nextMonth": "Следующий месяц",
      "prevMonth": "Предыдущий месяц"
    }
  },
  "tr-TR": {
    "datepicker": {
      "now": "Şimdi",
      "today": "Bugün",
      "cancel": "İptal",
      "clear": "Temizle",
      "confirm": "Tamam",
      "selectDate": "Tarih seç",
      "selectTime": "Saat seç",
      "startDate": "Başlangıç Zamanı",
      "endDate": "Bitiş Zamanı",
      "startTime": "Başlangıç Zamanı",
      "endTime": "Bitiş Zamanı",
      "prevYear": "Önceki Yıl",
      "nextYear": "Sonraki Yıl",
      "year": "Yıl",
      "month1": "Ocak",
      "month2": "Şubat",
      "month3": "Mart",
      "month4": "Nisan",
      "month5": "Mayıs",
      "month6": "Haziran",
      "month7": "Temmuz",
      "month8": "Ağustos",
      "month9": "Eylül",
      "month10": "Ekim",
      "month11": "Kasım",
      "month12": "Aralık",
      "weeksShort": {
        "sun": "Paz",
        "mon": "Pzt",
        "tue": "Sal",
        "wed": "Çar",
        "thu": "Per",
        "fri": "Cum",
        "sat": "Cmt"
      },
      "weeks": {
        "sun": "Pazar",
        "mon": "Pazartesi",
        "tue": "Salı",
        "wed": "Çarşamba",
        "thu": "Perşembe",
        "fri": "Cuma",
        "sat": "Cumartesi"
      },
      "months": {
        "jan": "Oca",
        "feb": "Şub",
        "mar": "Mar",
        "apr": "Nis",
        "may": "May",
        "jun": "Haz",
        "jul": "Tem",
        "aug": "Ağu",
        "sep": "Eyl",
        "oct": "Eki",
        "nov": "Kas",
        "dec": "Ara"
      },
      "nextMonth": "Sonraki Ay",
      "prevMonth": "Önceki Ay"
    }
  },
  "vi-VN": {
    "datepicker": {
      "now": "Hiện tại",
      "today": "Hôm nay",
      "cancel": "Hủy",
      "clear": "Xóa",
      "confirm": "OK",
      "selectDate": "Chọn ngày",
      "selectTime": "Chọn thời gian",
      "startDate": "Ngày bắt đầu",
      "endDate": "Ngày kết thúc",
      "startTime": "Thời gian bắt đầu",
      "endTime": "Thời gian kết thúc",
      "prevYear": "Năm trước",
      "nextYear": "Năm sau",
      "year": "Năm",
      "month1": "Tháng 1",
      "month2": "Tháng 2",
      "month3": "Tháng 3",
      "month4": "Tháng 4",
      "month5": "Tháng 5",
      "month6": "Tháng 6",
      "month7": "Tháng 7",
      "month8": "Tháng 8",
      "month9": "Tháng 9",
      "month10": "Tháng 10",
      "month11": "Tháng 11",
      "month12": "Tháng 12",
      "weeksShort": {
        "sun": "Chủ Nhật",
        "mon": "Thứ 2",
        "tue": "Thứ 3",
        "wed": "Thứ 4",
        "thu": "Thứ 5",
        "fri": "Thứ 6",
        "sat": "Thứ 7"
      },
      "weeks": {
        "sun": "Chủ Nhật",
        "mon": "Thứ Hai",
        "tue": "Thứ Ba",
        "wed": "Thứ Tư",
        "thu": "Thứ Năm",
        "fri": "Thứ Sáu",
        "sat": "Thứ Bảy"
      },
      "months": {
        "jan": "Tháng 1",
        "feb": "Tháng 2",
        "mar": "Tháng 3",
        "apr": "Tháng 4",
        "may": "Tháng 5",
        "jun": "Tháng 6",
        "jul": "Tháng 7",
        "aug": "Tháng 8",
        "sep": "Tháng 9",
        "oct": "Tháng 10",
        "nov": "Tháng 11",
        "dec": "Tháng 12"
      },
      "nextMonth": "Tháng tới",
      "prevMonth": "Tháng trước"
    }
  },
  "zh-CN": {
    "datepicker": {
      "now": "立即",
      "today": "今天",
      "cancel": "取消",
      "clear": "清除",
      "confirm": "确定",
      "selectDate": "选择日期",
      "selectTime": "选择时间",
      "startDate": "开始日期",
      "endDate": "结束日期",
      "startTime": "开始时间",
      "endTime": "结束时间",
      "prevYear": "上一年",
      "nextYear": "下一年",
      "year": "年",
      "month1": "一月",
      "month2": "二月",
      "month3": "三月",
      "month4": "四月",
      "month5": "五月",
      "month6": "六月",
      "month7": "七月",
      "month8": "八月",
      "month9": "九月",
      "month10": "十月",
      "month11": "十一月",
      "month12": "十二月",
      "weeksShort": {
        "sun": "周日",
        "mon": "周一",
        "tue": "周二",
        "wed": "周三",
        "thu": "周四",
        "fri": "周五",
        "sat": "周六"
      },
      "weeks": {
        "sun": "星期天",
        "mon": "星期一",
        "tue": "星期二",
        "wed": "星期三",
        "thu": "星期四",
        "fri": "星期五",
        "sat": "星期六"
      },
      "months": {
        "jan": "1月",
        "feb": "2月",
        "mar": "3月",
        "apr": "4月",
        "may": "5月",
        "jun": "6月",
        "jul": "7月",
        "aug": "8月",
        "sep": "9月",
        "oct": "10月",
        "nov": "11月",
        "dec": "12月"
      },
      "nextMonth": "下个月",
      "prevMonth": "上个月"
    }
  },
  "zh-TW": {
    "datepicker": {
      "now": "現在",
      "today": "今天",
      "cancel": "取消",
      "clear": "清除",
      "confirm": "確定",
      "selectDate": "選取日期",
      "selectTime": "選取時間",
      "startDate": "開始日期",
      "endDate": "結束日期",
      "startTime": "開始時間",
      "endTime": "結束時間",
      "prevYear": "去年",
      "nextYear": "明年",
      "year": "年",
      "month1": "一月",
      "month2": "二月",
      "month3": "三月",
      "month4": "四月",
      "month5": "五月",
      "month6": "六月",
      "month7": "七月",
      "month8": "八月",
      "month9": "九月",
      "month10": "十月",
      "month11": "十一月",
      "month12": "十二月",
      "weeksShort": {
        "sun": "週日",
        "mon": "週一",
        "tue": "週二",
        "wed": "週三",
        "thu": "週四",
        "fri": "週五",
        "sat": "週六"
      },
      "weeks": {
        "sun": "週日",
        "mon": "週一",
        "tue": "週二",
        "wed": "週三",
        "thu": "週四",
        "fri": "週五",
        "sat": "週六"
      },
      "months": {
        "jan": "一月",
        "feb": "二月",
        "mar": "三月",
        "apr": "四月",
        "may": "五月",
        "jun": "六月",
        "jul": "七月",
        "aug": "八月",
        "sep": "九月",
        "oct": "十月",
        "nov": "十一月",
        "dec": "十二月"
      },
      "nextMonth": "下個月",
      "prevMonth": "上個月"
    }
  }
};
const lang = i18n[locale] ? i18n[locale] : i18n[defaultLocale];

addLang(lang);
